import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".5"
    }, [
      _createElementVNode("path", { d: "M2 9.1v6c0 .994.716 1.8 1.6 1.8h12.8c.884 0 1.6-.806 1.6-1.8v-6" }),
      _createElementVNode("path", { d: "M18 6.1V4.3c0-.994-.716-1.8-1.6-1.8H3.6c-.884 0-1.6.806-1.6 1.8v1.8l8 4.8 8-4.8z" })
    ], -1)
  ])))
}
export default { render: render }